import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import { Button } from '../Buttons/Button'

interface InformationModalProps {
  isOpen: boolean
  title?: string
  onAccept?: () => void
  onClose: () => void
  children?: React.ReactNode
}

const InformationModal: FC<InformationModalProps> = ({ isOpen, title, onAccept, onClose, children }) => {
  const { t } = useTranslation()

  const footer = (
    <Button variant="secondary" size="compact" style={{ padding: '0 20px' }} onClick={onAccept}>
      {t('modal.confirm')}
    </Button>
  )

  return (
    <BaseModal isOpen={isOpen} title={title || t('modal.defaultTitle')} onClose={onClose} footer={footer}>
      {children}
    </BaseModal>
  )
}

export default InformationModal
